import React from 'react';
import { Modal, Icon } from 'semantic-ui-react';
import { SvgIcon } from '../../common';
import './subscribe_modal.scss';

const FEATURES = [
    'Full platform access',
    'Unlimited ecosystem exploration',
    'AI-powered product & technology discovery',
    'Supplier and customer intelligence',
    'Access to global manufacturing databases',
    'Company and technology profiling',
    'Industry insights & ecosystem mapping',
    'Personalized technology feed',
    'Networking & connection tools',
    'Access to emerging industry ecosystems',
    'Priority onboarding support',
];

const CONTACT_EMAIL = 'ankit.singhal@mappes.io';

const SubscribeModal = ({ open, onClose }) => (
    <Modal
        open={open}
        onClose={onClose}
        className="subscribe-modal"
        size="small"
        closeIcon={<SvgIcon className="modal-close" name="close" viewbox="0 0 23.126 23.126" />}
    >
        <Modal.Content>
            <div className="subscribe-modal-inner">
                <p className="subscribe-modal-eyebrow">Choose Your Access Plan</p>
                <h2 className="subscribe-modal-title">Mappes Professional Access</h2>
                <p className="subscribe-modal-subtitle">
                    The complete platform for industrial intelligence and ecosystem discovery.
                </p>

                <div className="subscribe-modal-price-card">
                    <div className="subscribe-modal-price">
                        <span className="subscribe-modal-amount">$3,000</span>
                        <span className="subscribe-modal-period">/ Year</span>
                    </div>

                    <ul className="subscribe-modal-features">
                        {FEATURES.map((feature) => (
                            <li key={feature}>
                                <Icon name="check circle" className="subscribe-modal-check" />
                                <span>{feature}</span>
                            </li>
                        ))}
                    </ul>
                </div>

                <div className="subscribe-modal-contact">
                    <p>
                        To access the entire system contact{' '}
                        <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>
                    </p>
                </div>

                <div className="subscribe-modal-note">
                    <div className="subscribe-modal-note-icon">
                        <Icon name="shield alternate" />
                    </div>
                    <div className="subscribe-modal-note-text">
                        <p className="subscribe-modal-note-heading">
                            Access is limited to verified industry professionals.
                        </p>
                        <p className="subscribe-modal-note-body">
                            To maintain ecosystem quality and relevance, all subscriptions are
                            manually reviewed and activated.
                        </p>
                    </div>
                </div>
            </div>
        </Modal.Content>
    </Modal>
);

export default SubscribeModal;
